// Please keep keys lowercase!
exports.supportedLanguages = {
  en: 'English',
  hr: 'hrvatski',
};
